
/* Library */
import React, { Component } from 'react';
// import commonUtil from '../../../../../utils/commonUtil';
import CheckBox from '../../../../../../components/ZUILib/CheckBox';
import CheckboxData from '../components/CheckBoxData';
import Warning from '../../../../../../components/Warning';
import commonUtil from '../../../../../../utils/commonUtil';

export default class GiftPreferencesWeb extends Component {
  constructor() {
    super();
    this.pageLoad = true;
    this.showAddressWithPreference = this.showAddressWithPreference.bind(this);
    this.state = {
      displayStyle: 'none',
    };
  }
  showAddressWithPreference(data) {
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    if (!data.checked) {
      this.props.preferredDeliveryDayDetails(eventID, 'false');
      this.setState({ displayStyle: 'none' });
    }
    if (data.checked) {
      this.props.preferredDeliveryDayDetails(eventID, 'true');
      this.setState({ displayStyle: 'block' });
      this.pageLoad = true;
    }
  }
  getUpdatedData() {
    return this.checkboxData.getUpdatedData();
  }

  handleDeliveryPreferenceCheck = (deliveryDayAndAddressInfo) => {
    if (deliveryDayAndAddressInfo) {
    //   const { deliveryDayAndAddressInfo } = this.props;
      const selectedDays = [];
      deliveryDayAndAddressInfo.map((info) => {
        const days = info.delieveryDaysInfo.filter(day => day.opted === true);
        return selectedDays.push(days);
      });

      if (selectedDays.length > 0 && selectedDays[0].length > 0) {
        this.setState({ displayStyle: 'block' });
        this.chk.setChecked(true);
      } else if (!this.pageLoad) {
        this.setState({ displayStyle: 'none' });
        this.chk.setChecked(false);
      }
    } else {
      this.setState({ displayStyle: 'none' });
      this.chk.setChecked(false);
    }
  }
  // componentDidMount() {
  //   this.props.deliveryDayAndAddressInfo.map((deliveryData) => {
  //     deliveryData.delieveryDaysInfo.map((data) => {
  //       if (data.opted === true) {
  //           // this.forchk.style.display = 'block';
  //         this.setState({ displayStyle: 'block' });
  //         this.chk.setChecked(true);
  //       }
  //       return false;
  //     }); return false;
  //   });
  // }

  componentWillReceiveProps = (nextprops) => {
    if ((nextprops.deliveryDayAndAddressInfo && nextprops.deliveryDayAndAddressInfo.deliveryDayAndAddressInfo > 0) || (!this.pageLoad && nextprops.deliveryDayAndAddressInfo === null && nextprops.deliveryDayPreference && nextprops.deliveryDayPreference.status && nextprops.deliveryDayPreference.status.status === 'success')) {
      this.handleDeliveryPreferenceCheck((nextprops.deliveryDayAndAddressInfo && nextprops.deliveryDayAndAddressInfo.deliveryDayAndAddressInfo) || null);
    }
  }

  handleSumbitChangedAddressPreferences = () => {
    this.props.handleSumbitChangedAddressPreference();
    this.pageLoad = false;
  };

  render() {
    const lables = this.props.lables;
    // const deliveryDayAndAddressInfo = this.props.deliveryDayAndAddressInfo;

    const eventStatusForSuspended = this.props.eventStatusForSuspended;

    let displayStyle = this.state.displayStyle;
    let deliveryDayAndAddressInfo;
    if (this.props.deliveryDayPreference && this.props.deliveryDayPreference.preferredDeliveryDayDetails &&
      this.props.deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo) {
      deliveryDayAndAddressInfo = JSON.parse(JSON.stringify(this.props.deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo));
      // this._tempDeliveryDayPreference = this.props.deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo;
      // this.deliveryDayNotApplicables = JSON.parse(JSON.stringify(this.props.deliveryDayNotApplicables));

      if (deliveryDayAndAddressInfo) {
        deliveryDayAndAddressInfo.map((deliveryData) => {
          deliveryData.delieveryDaysInfo.map((data) => {
            if (data.opted === true) {
              displayStyle = 'block';
            } return false;
          }); return false;
        });
      }
    }


    return (
      <div>
        <div className="row">
          <div className="col-sm-9 myEventInfo noBorder addressIntro">
            <h1>Preferencias de entrega de regalos</h1>
            <div className="new" style={{ display: 'block' }} ref={errormessage => this.errormessage = errormessage} />
            <p>{commonUtil.getLabel(lables.editEventPrefreneces, 'editEventPrefreneces.delivery.schedule.message')}</p>
          </div>
        </div>

        <div className="row giftPreference">
          <div className="col-sm-12 p-l-20">
            <CheckBox
              id="showAddress"
              displayName={commonUtil.getLabel(lables.editEventPrefreneces, 'eventManagement.preferredDeliveryDates.checkboxText')}
              getSelectedValue={this.showAddressWithPreference}
              ref={chk => this.chk = chk}
              checked={displayStyle === 'block' ? 'checked' : ''}
              disabled={eventStatusForSuspended === true ? 'disabled' : null} // show disabled when event is suspended/deleted
            />
          </div>
          <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
        </div>
        {deliveryDayAndAddressInfo &&
          <div id="CheckboxData" style={{ display: displayStyle }} ref={forchk => this.forchk = forchk}>
            <CheckboxData
              _handleCancelTemproryAddressPreferenceChanges={this.props._handleCancelTemproryAddressPreferenceChanges}
              handleSumbitChangedAddressPreference={this.handleSumbitChangedAddressPreferences}
              changeAddressDeliveryPreference={this.props.changeAddressDeliveryPreference}
              deliveryDayAndAddressInfo={deliveryDayAndAddressInfo}
              showButton={this.props.showButton}
              ref={chd => this.checkboxData = chd}
              eventStatusForSuspended={eventStatusForSuspended}
            />
          </div>}
      </div>
    );
  }
}

